<div class="flex w-full align-items-center justify-content-center">
	<i class="pi {{icon}} text-4xl mr-3"></i>
	<div class="flex flex-column justify-content-start">
		<div *ngIf="row1 !== ''">{{ row1 | translate }}</div>
		<div *ngIf="row2 !== ''">{{ row2 | translate }}</div>
	</div>
</div>
<div class="grid mt-3">
	<div class="col-12 flex justify-content-center">
		<button type="button" pButton pRipple (click)="closeDialog();"
			label="{{ 'CLOSE' | translate }}"
			styleClass="p-dialog p-dialog-footer"
			class="p-button-secondary mx-1">
		</button>
	</div>
</div>